const markerKey = (token) => `cds-points-purchase:${token}`;
export const cdsPointsAttemptKey = (token, ownerId) => `cds-points:${ownerId}:${token}`;

/** CDS account capability remains independent of points-settlement activation. */
export function hasCdsAccount(env) {
  return Boolean(env?.reserhub?.auth?.allowedAuthMethods?.includes('cds_frequent_passenger'));
}

/** Read recovery before the first paint; the purchase marker never contains credentials. */
export function readCdsPointsRecovery(purchase, ownerId, cdsAccountEnabled = false) {
  try {
    const marker = sessionStorage.getItem(markerKey(purchase.token));
    let owner = marker ? JSON.parse(marker).ownerId : null;
    // Preserve attempts saved by an earlier frontend revision, including signed-out reloads.
    if (!owner) {
      const suffix = `:${purchase.token}`;
      for (let index = 0; index < sessionStorage.length; index += 1) {
        const key = sessionStorage.key(index);
        if (key?.startsWith('cds-points:') && key.endsWith(suffix)) {
          owner = key.slice('cds-points:'.length, -suffix.length);
          break;
        }
      }
    }
    const saved = ownerId
      ? sessionStorage.getItem(cdsPointsAttemptKey(purchase.token, ownerId))
      : null;
    const parsed = saved ? JSON.parse(saved) : null;
    const attempt = parsed?.key && parsed?.quoteId ? parsed : null;
    return { blocked: Boolean(marker || owner || saved), ownerId: owner, attempt };
  } catch {
    return {
      blocked: Boolean(
        cdsAccountEnabled || purchase.cdsPointsEnabled || purchase.cdsPointsRedemptionId,
      ),
      unavailable: true,
    };
  }
}

/** Both records must be durable before the only mutating provider request. */
export function persistCdsPointsAttempt(token, ownerId, attempt) {
  sessionStorage.setItem(cdsPointsAttemptKey(token, ownerId), JSON.stringify(attempt));
  sessionStorage.setItem(markerKey(token), JSON.stringify({ ownerId: String(ownerId) }));
}

/** Only definitive rejection or completed issuance releases the purchase marker. */
export function clearCdsPointsAttempt(token, ownerId) {
  try {
    sessionStorage.removeItem(cdsPointsAttemptKey(token, ownerId));
    sessionStorage.removeItem(markerKey(token));
  } catch {
    // A failed cleanup retains a conservative recovery marker; it cannot undo server confirmation.
  }
}

/** Keep coupons unavailable for a live selection or a durable, unresolved CDS operation. */
export function isCdsCouponBlocked(purchase, cdsAccountEnabled = false) {
  if (purchase.cdsPointsPreview != null || purchase.cdsPointsRedemptionId) return true;
  const operation = purchase.cdsPointsRedemption;
  if (operation && operation.status !== 'rejected') return true;
  return readCdsPointsRecovery(purchase, null, cdsAccountEnabled).blocked;
}
